module.exports = "/images/check_small.svg?e6539d180ed96bd128fcd723a15099ac";